import React, { FC } from 'react';

interface ILinkText {
  link: string | undefined | null;
  text: string;
}

export const LinkText: FC<ILinkText> = ({ link, text = '' }) => (
  <div>
    {link ? (
      <a className="font-regular-base" href={link} target="_blank" rel="noreferrer noopener">
        {text}
      </a>
    ) : (
      <span>{text}</span>
    )}
  </div>
);
